export default {
  SEARCH_CATALOG_ALLIANZ_FINANCIAL_INSTITUTION_QUERY: Symbol.for('SEARCH_CATALOG_ALLIANZ_FINANCIAL_INSTITUTION_QUERY'),
  CATALOG_ALLIANZ_FINANCIAL_INSTITUTION_REPOSITORY: Symbol.for('CATALOG_ALLIANZ_FINANCIAL_INSTITUTION_REPOSITORY'),
  CATALOG_ALLIANZ_FINANCIAL_INSTITUTION_STATE_MANAGER: Symbol.for('CATALOG_ALLIANZ_FINANCIAL_INSTITUTION_STATE_MANAGER'),
};
